// Communication with the vimeo embed requires the postMessage protocol
// https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage

/** pause a vimeo video stored in an iframe
 *
 * - `elem` — the iframe
 */
export function play(elem: HTMLIFrameElement): void {
    elem.contentWindow?.postMessage(JSON.stringify({ method: 'play' }), '*');
}

/** play a vimeo video stored in an iframe
 *
 * - `elem` — the iframe
 */
export function pause(elem: HTMLIFrameElement): void {
    elem.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), '*');
}

/** returns true if the element is an iframe of vimeo */
export const isVimeoEmbed = (x: unknown): x is HTMLIFrameElement =>
    x instanceof HTMLIFrameElement
        && x.src.startsWith('https://player.vimeo.com');

/** pause all vimeo embeds of a given element */
export function pauseAll<T extends HTMLElement>(elem: T): T {
    Array.from(elem.querySelectorAll<HTMLIFrameElement>('iframe'))
        .filter(isVimeoEmbed)
        .forEach(pause);
    return elem;
}

export function vimeo(x: string) {
    return `https://player.vimeo.com/video/${x}?loop=1&title=0&byline=0&portrait=0&muted=1`;
}
